module.exports = __webpack_public_path__ + "img/9-me.7314f13.jpg";